module.exports = __webpack_public_path__ + "img/21.257d8245.gif";